import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import styles from './index.module.scss';
import { images } from 'utils/icons';

import cn from 'classnames';

const downloadMedia = url => {
  window.open(url);
};

const SingleAudioPlayer = ({ value, condense }) => {
  const [mediaPlay, setMediaPlay] = useState(false);
  const musicRef = useRef(null);

  const handleMediaPlay = () => {
    if (mediaPlay) {
      musicRef.current.pause();
      setMediaPlay(false);
    } else {
      musicRef.current.play();
      setMediaPlay(true);
    }
    musicRef.current.onended = () => {
      setMediaPlay(false);
    };
  };

  useEffect(() => {
    onClickResetAudioFile(); // this will automaticlly clear the previous audio url and replace with the new one
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onClickResetAudioFile = () => {
    if (musicRef.current) {
      musicRef.current.src = value;
    }
  };

  return (
    <div className={styles.container}>
      {value && (
        <div
          className={cn(styles.mediaPlayer, {
            [styles.condense]: condense,
          })}
        >
          <audio ref={musicRef} className={styles.audio}>
            <source src={value} type="audio/mpeg" />
            <Image src={images.downloadMedia} onClick={downloadMedia}>
              This browser does not support the HTML5 video element.
            </Image>
          </audio>
          <Image
            onClick={handleMediaPlay}
            className={cn(styles.center, { [styles.pointer]: value })}
            src={
              value
                ? mediaPlay
                  ? images.pauseMedia.default
                  : images.playMedia.default
                : images.audioMediaPlaceholder.default
            }
          />
        </div>
      )}
    </div>
  );
};

SingleAudioPlayer.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      mediaType: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  condense: PropTypes.bool,
};

export default SingleAudioPlayer;
